import client from '@stores/apollo'
import gql from 'graphql-tag'
import { ScenarioGroupFragment } from '@api/fragments'
import { IScenarioGroup } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface DeleteScenarioGroupMutationInput {
  id: string
}

interface IPayload {
  deleteScenarioGroup: {
    scenarioGroup: IScenarioGroup
  }
}

const mutateHandler = handleFetchResult<IPayload, IScenarioGroup>({
  handler: (data) => data.deleteScenarioGroup.scenarioGroup,
  name: 'Scenario Group',
})

export default function remove(input: DeleteScenarioGroupMutationInput): Promise<IScenarioGroup> {
  return client.gql.mutate<IPayload>({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation DeleteScenarioGroup($input: DeleteScenarioGroupMutationInput!) {
    deleteScenarioGroup(input: $input) {
      scenarioGroup {
        ...ScenarioGroupFragment
      }
    }
  }
  ${ScenarioGroupFragment}
`
